"use client";

import { useLocale } from "@i18n/react";
import { usePath } from "@packages/framework";

import { pathMatchFn } from "./pathMatchFn";

export const usePathMatch = () => {
  const path = usePath();
  const locale = useLocale();

  return (href: string, exact: boolean = false) =>
    pathMatchFn(href, exact, path, locale);
};
